import { useState } from "react";
import { useTimeoutFn } from "react-use";
import { PAGE_TRANSITION_DURATION } from "../../data/animationConfig";

export const usePageReady = (): [boolean] => {
  const [pageReady, setPageReady] = useState(false);

  useTimeoutFn(() => setPageReady(true), PAGE_TRANSITION_DURATION * 1000);

  return [pageReady];
};
